<template>
  <div>
    <div>
      <div class="d-flex flex-row-reverse">
        <button
          type="button"
          @click="adicionarRegra"
          class="button mt-2 mb-2 button-primary"
        >
          Adicionar Segmento
        </button>
      </div>
      <div class="overflow-auto container-segmentos">
        <h2>RESTRIÇÕES POR SEGMENTO:</h2>

        <div v-if="!form.dimensoes.length">
          <em>Nenhuma restrição cadastrada ainda.</em>
        </div>

        <div v-for="(dimensao, index) in form.dimensoes" class="mt-2">
          <p v-if="index > 0" class="text-center mb-3 fw-bold">— Ou —</p>
          <RegrasSegmentos
            ref="segmento"
            :form="form"
            :dimensaoRegra="dimensao"
            :dimensoes="dimensoes"
            :index="index"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/helpers/apiRequest";
import SelectableListBase from "../../../../components/selecoes/SelectableListBase.vue";

import _remove from "lodash/remove";
import RegrasSegmentos from "../../../../components/selecoes/RegrasSegmentos.vue";

const findIndexRestricao = (tipo, form) => {
  return form.restricoes.findIndex((restricao) => restricao.tipo === tipo);
};

const initialDimensao = () => ({
  dimensao1: "",
  dimensao2: "",
  dimensao3: "",
  dimensao4: "",
  dimensao5: "",
  dimensao6: "",
  dimensao7: "",
  dimensao8: "",
  dimensao9: "",
  dimensao10: "",
});

export default {
  name: "Segmentos",
  props: {
    form: { type: Object, required: true },
    dimensoes: { type: Array, required: true },
  },
  components: { RegrasSegmentos },
  data() {
    return {
      indexRestricao: findIndexRestricao("cliente", this.form),
      loading: false,
    };
  },
  methods: {
    adicionarRegra() {
      this.form.dimensoes.unshift(initialDimensao());
    },
  },
};
</script>

<style>
.container-segmentos {
  max-height: 500px;
}
</style>
